import React from 'react';
import { Link } from 'react-router';
import { browserHistory } from 'react-router';

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    };

    this.fadeOutVideo = this.fadeOutVideo.bind(this);
  }

  componentDidMount() {
    this.refs.myVideo.addEventListener('ended', this.fadeOutVideo, false);
  }

  fadeOutVideo(e) {
    browserHistory.push('/watch');
  }

  render() {
    return(
      <div className="home">
        <div className="table">
          <div className="table-cell">
          <div className="videoWrapper">
              <video ref="myVideo" autoPlay muted>	
                <source src="/home-dance.mov" />	
              </video>	
            </div>
          </div>
        </div>

        <div className="menu-bottom">
          <Link to="/watch">Start</Link>
        </div>
      </div>
    )
  }
}

export default Home;



// WEBPACK FOOTER //
// src/Home.js